import { Provider } from 'react-redux';
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet } from 'react-router-dom';
import { ToastContainer } from '@pmi/dsm-react';
import { store } from './shared/store';
import Layout from './shared/navigation/Layout';
import '@pmi/dsm-react/dist/assets/styles/styles.scss';
import './App.scss';
import AppHelmet from './shared/components/AppHelmet';
import ScrollToTop from './shared/components/ScrollToTop';
import RootBoundary from './RootBoundary';
import SessionCheck from './shared/navigation/SessionCheck';
import AutoSwitcher from './shared/navigation/AutoSwitcher';

export default function App() {
  return (
    <Provider store={store}>
      <ScrollToTop />
      <AppHelmet />
      <Layout>
        <SessionCheck
          render={() => (
            <AutoSwitcher>
              <ErrorBoundary FallbackComponent={RootBoundary}>
                <Outlet />
              </ErrorBoundary>
            </AutoSwitcher>
          )}
        />
        <ToastContainer />
      </Layout>
    </Provider>
  );
}
